module.exports = __webpack_public_path__ + "static/media/Checkmark.75f1b1e9.svg";